module.exports = __webpack_public_path__ + "media/customizations/bedfordlife/back-3f518f3e4c283d7fdbdf1db535c21f6f.jpg";